function positiveId(id: number): number {
  if (!Number.isSafeInteger(id) || id <= 0) {
    throw new RangeError("workingTemplateIdx must be a positive integer");
  }
  return id;
}

export const workingTemplatePolicyRoutes = {
  binding: (workingTemplateIdx: number) =>
    `/api/working-templates/${encodeURIComponent(
      String(positiveId(workingTemplateIdx))
    )}/base-policy-binding`
} as const;

export default workingTemplatePolicyRoutes;
